import React from "react";
import NavMenuComponent from "./NavMenuComponent";
import { getMenuItems } from "./ViewNavUtils";

const NavMenu = (props) => {
  const menu = getMenuItems(props);
  return <NavMenuComponent {...props} menu={menu} />;
};

export default NavMenu;
